import { isEmpty } from 'lodash';

export function isFornecedorHomologado(fornecedoresProduto, idFornecedor) {
  return fornecedoresProduto
    .filter(fp => fp.homologado)
    .map(fp => fp.fornecedor.id)
    .includes(idFornecedor);
}

export function filterProdutoNaoHomologado(produto, idFornecedor) {
  const { fornecedoresProduto } = produto;
  if (isEmpty(fornecedoresProduto) || isEmpty(fornecedoresProduto.filter(fp => fp.homologado))) {
    return false;
  }
  return !isFornecedorHomologado(fornecedoresProduto, idFornecedor);
}

export function getFornecedoresHomologados(produto) {
  return produto.fornecedoresProduto.filter(fp => fp.homologado) || [];
}
